import { Layout } from '@evisort/eds/components/Layout/Layout';
import { Modal } from '@evisort/eds/components/Modal/Modal';
import { Text } from '@evisort/eds/components/Text/Text';
import { defineMessages, useIntl } from 'react-intl';

import { useSidebarNavPreference } from './SidebarNavPreferenceContext';

const messages = defineMessages({
  title: {
    id: 'SidebarNavOnboarding.title',
    defaultMessage: 'Welcome to the new Evisort',
    description:
      'Title for the first-time sidebar navigation onboarding modal.',
  },
  intro: {
    id: 'SidebarNavOnboarding.intro',
    defaultMessage: 'We are introducing a new sidebar navigation preview.',
    description:
      'Introductory copy for the sidebar navigation onboarding modal.',
  },
  navPoint: {
    id: 'SidebarNavOnboarding.navPoint',
    defaultMessage:
      'Navigation items have moved and been regrouped—for example, Groups, Documents, Library, and Custom AI now live in the sidebar.',
    description: 'Onboarding paragraph explaining navigation changes.',
  },
  optOutPoint: {
    id: 'SidebarNavOnboarding.optOutPoint',
    defaultMessage:
      'This is a preview. You can switch back to classic navigation anytime from the bottom of the sidebar.',
    description:
      'Onboarding paragraph explaining how to opt out of the preview.',
  },
  continue: {
    id: 'SidebarNavOnboarding.continue',
    defaultMessage: 'Got it',
    description:
      'Primary action to dismiss the sidebar navigation onboarding modal.',
  },
});

const paragraphs = [messages.intro, messages.navPoint, messages.optOutPoint];

export function SidebarNavOnboardingModal() {
  const intl = useIntl();
  const { isOnboardingVisible, dismissOnboarding } = useSidebarNavPreference();

  const continueText = intl.formatMessage(messages.continue);

  return (
    <Modal
      isVisible={isOnboardingVisible}
      header={{
        title: intl.formatMessage(messages.title),
      }}
      footer={{
        actions: [
          {
            label: continueText,
            text: continueText,
            variant: 'primary',
            onClick: dismissOnboarding,
          },
        ],
      }}
      onHide={dismissOnboarding}
    >
      <Layout direction="column" spacing="m">
        {paragraphs.map((message) => (
          <Text as="p" key={message.id}>
            {intl.formatMessage(message)}
          </Text>
        ))}
      </Layout>
    </Modal>
  );
}
